export default __webpack_public_path__ + "static/media/confused_low.ce96df42.png";